import { hasPermission, hasActiveFeatureGate } from '@sopranodesign/pulse-auth';

import { VoiceLink } from './Pages/index';

const routes = [
  {
    name: 'Voice',
    path: '/voice-link',
    component: VoiceLink,
    canAccess: [
      hasActiveFeatureGate('channel - voice'),
      hasPermission('view voice settings')
    ],
    actions: []
  }
];

export default routes;
